import React from 'react';
import {Form, Textarea, List} from 'components';
import {useNamedSelector} from 'helpers';

export function Relationships() {
  return (
    <Form {...useNamedSelector('clarity.form', { name: 'relationships' })}>
      <List tiny-gutter>
        <List.Title>What are you longing for in your relationship/a relationship?</List.Title>
        <Textarea single name="1" />
        <List.Title>What are the most important qualities to you in a partner?</List.Title>
        <Textarea single name="2" />
        <List.Title>What are the things you bring to a relationship, positive and negative?</List.Title>
        <Textarea single name="3" />
        <List.Title>Where do you hold back?</List.Title>
        <Textarea single name="4" />
        <List.Title>What is non-negotiable?</List.Title>
        <Textarea single name="5" />
        <List.Title>If you are in a relationship, what about it works? What Doesn't?</List.Title>
        <Textarea single name="6" />
        <List.Title>Think of a couple whose relationship you admire. What do you notice about that relationship?</List.Title>
        <Textarea single name="7" />
        <List.Title>How would you describe your dream relationship?</List.Title>
        <Textarea single name="8" />
        <List.Title>Describe how you feel when you have the relationship you want</List.Title>
        <Textarea single name="9" />
      </List>
    </Form>
  );
}
